import { createAsyncThunk } from '@reduxjs/toolkit';
import { DateTime } from 'luxon';

import { authGet } from '../../../utils/request';

const getPriorityCoOrders = createAsyncThunk('coOrders/getPriorityCoOrders',
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await authGet('/co/orders',
        {
          params: {
            size: 1,
            marketplaceDateTo: DateTime.now()
              .minus({ days: 6 })
              .toISODate(),
            orderStatus: [
              'Ready asb',
              'Out of stock',
              'Out of reserve',
              'Part box',
              'Pack box',
              'New',
            ]
          }
        });
      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  });

export default getPriorityCoOrders;
